import { environment } from '@environment';

export const seatMapApi = {
  seatMapRoute: `${environment.api.netactica}/seatmapv2`,
  itineraryDetail: `${environment.api.services}/api/travel-proxy-ms/itinerary?id={detailId}`,
  seatMapFlight: `${environment.api.netactica}/seatmapv2/{itineraryId}/{airReservationId}/{flightIdx}`,
  seatsFlight: `${environment.api.netactica}/seatmapv2/{itineraryId}/{airReservationId}/{flightIdx}/seats`,
  removeSeatInFlight: `${environment.api.netactica}/seatmapv3/{itineraryId}/{airReservationId}/` +
    '{flightIdx}/{seatNumber}/{firstName}/{lastName}/{firstPaxEmail}'
};
